// extracted by mini-css-extract-plugin
export default {"ModalPage":"Modal_ModalPage__2A3Gy","Hide":"Modal_Hide__nEDaI","Modal":"Modal_Modal__+GJqR","CloseContainer":"Modal_CloseContainer__H4Fcy","Close":"Modal_Close__+MnZI"};